import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Svg, Polygon } from '@react-pdf/renderer';
import logo from "../assets/logo.png";
import phone from "../assets/phone.png";
import red from "../assets/red.png";
import email from "../assets/email.png";
import banco from "../assets/banco.png";

const styles = StyleSheet.create({
    page: {
        fontSize: 11,
        fontFamily: 'Helvetica',
        lineHeight: 1.5,
        position: 'relative',
        padding: 29,
    },
    headerBar: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 50,
    },
    footerBar: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 50,
        backgroundColor: '#D3D3D3',
        flexDirection: 'row',
    },
    footerContent: {
        flexDirection: 'row',
        justifyContent: 'space-between', // reparte el espacio entre columnas
        alignItems: 'center',
        paddingHorizontal: 20,
    },
    header: {
        marginBottom: 20,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 10
    },
    titleView: {
        marginBottom: 20,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginTop: 20,
        width: 200
    },
    totalView: {
        marginTop: 20
    },
    logo: {
        width: 110,
        height: 100,
    },
    title: {
        fontSize: 13,
        fontWeight: 'bold',
        textAlign: 'right',
    },
    titleProyect: {
        fontSize: 13,
        fontWeight: 'bold',
        textAlign: 'left',
    },
    section: {
        marginBottom: 16,
    },
    condiciones: {
        marginLeft: 25,
        marginRight: 25
    },
    condicionesText: {
        textAlign: 'justify',
        lineHeight: 0.9
    },
    subtitle: {
        fontSize: 13,
        marginBottom: 8,
        fontWeight: 'bold',
        color: '#111827',
    },
    textPage2: {
        fontSize: 12,
        fontWeight: 'bold',
        color: '#4F4A4A'
    },
    totalText: {
        fontSize: 13,
        textAlign: 'right',
        marginBottom: 8,
        fontWeight: 'bold',
        color: '#111827',
    },
    line: {
        marginBottom: 4,
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    bold: {
        fontWeight: 'bold',
    },
    total: {
        fontSize: 12,
        fontWeight: 'bold',
        marginTop: 8,
        color: '#1d4ed8',
    },
});

function PDFCotizacion({ datos, totales, camposExtras }) {

    const fecha = new Date().toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });
    // const total = totales.total.toLocaleString();
    // const subtotal = totales.subtotal.toLocaleString();
    // const cantidadUnidades = Number(totales.cantidadUnidades) || 0;
    // const precioPorUnidades = totales.precioCOPUnidades
    //     ? totales.precioCOPUnidades.toLocaleString()
    //     : '0';

    const renderLinea = (label, value, descripcion) => (
        <View style={{ marginBottom: 1 }}>
            <Text style={styles.line}>
                <Text style={styles.bold}> • </Text>
                <Text> {label} {value} {descripcion}</Text>
            </Text>
        </View>
    );

    const items = [];

    if (datos.renderPlantasTipoTorre > 0) {
        items.push(
            renderLinea(
                `${datos.renderPlantasTipoTorre} Planta(s) tipo torre`,
                datos.descripcionRenderPlantasTipoTorre
            )
        );
    }

    if (datos.renderPlantaAptoTipico > 0) {
        items.push(
            renderLinea(
                `${datos.renderPlantaAptoTipico} Planta(s) apto típico`,
                datos.descripcionRenderPlantasAptoTipico
            )
        );
    }

    if (datos.plantasArquitectonicasCotas > 0) {
        items.push(
            renderLinea(
                `${datos.plantasArquitectonicasCotas} Planta(s) con cotas`,
                datos.descripcionRenderArquitectonicas
            )
        );
    }

    if (datos.renderInteriores > 0) {
        items.push(
            renderLinea(
                `${datos.renderInteriores} Imagen(es) interior(es)`,
                datos.descripcionRenderInteriores
            )
        );
    }

    if (datos.renderExterior > 0) {
        items.push(
            renderLinea(
                `${datos.renderExterior} Imagen(es) exterior(es)`,
                datos.descripcionRenderExterior
            )
        );
    }

    if (datos.renderFotomontaje > 0) {
        items.push(
            renderLinea(
                `${datos.renderFotomontaje} Imagen(es) fotomontaje`,
                datos.descripcionRenderFotomontaje
            )
        );
    }

    if (datos.renderAmenties > 0) {
        items.push(
            renderLinea(
                `${datos.renderAmenties} Imagen(es) amenities`,
                datos.descripcionRenderAmenties
            )
        );
    }

    const chunkSize = 4;
    const columnas = [];

    for (let i = 0; i < items.length; i += chunkSize) {
        columnas.push(items.slice(i, i + chunkSize));
    }

    return (
        <Document title={`${datos.idCliente}_${datos.nombreCliente}_${datos.nombreProyecto}_${fecha}`}>

            <Page size="LETTER" style={styles.page}>

                <View style={styles.headerBar}>
                    <Svg viewBox="0 0 630 50" width="100%" height="50">
                        <Polygon
                            points="0,0 380,0 345,50 0,50"
                            fill="#D3D3D3"
                        />
                    </Svg>
                </View>

                <View style={styles.footerBar} fixed>

                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                        <Image
                            src={phone}
                            style={{ width: 22, height: 20, marginRight: 5 }}
                        />
                        <Text style={{ fontSize: 12, fontWeight: 'bold' }}>(+57) 3166994046</Text>
                    </View>


                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                        <Image
                            src={red}
                            style={{ width: 23, height: 20, marginRight: 5 }}
                        />
                        <Text style={{ fontSize: 12, fontWeight: 'bold' }}>www.armyone.co</Text>
                    </View>


                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                        <Image
                            src={email}
                            style={{ width: 24, height: 20, marginRight: 5 }}
                        />
                        <Text style={{ fontSize: 12, fontWeight: 'bold' }}>manager@armyone.co</Text>
                    </View>
                </View>

                <View style={{ alignItems: 'center', marginTop: 20 }}>
                    <Image src={logo} style={styles.logo} />
                </View>

                <View style={{ marginLeft: 'auto' }}>
                    <Text style={styles.titleProyect}>{datos.numeroCotizacion}</Text>
                </View>

                <View style={styles.header}>
                    <Text style={styles.title}>Santiago de Cali, {fecha}</Text>
                </View>

                <View>
                    <Text>Estimado(s) Sr. (es),</Text>
                    <Text style={styles.titleProyect}>{datos.nombreCliente}</Text>
                </View>

                <View style={styles.header} />

                <View style={{ flexDirection: "row", gap: 10 }}>
                    {datos.correoCliente && (
                        <Text>Correo: {datos.correoCliente}</Text>
                    )}

                    {datos.telefonoCliente && (
                        <Text>Tel: {datos.telefonoCliente}</Text>
                    )}
                </View>

                <View style={styles.titleView}>
                    <Text style={styles.titleProyect}>{datos.nombreProyecto}</Text>
                </View>

                <View style={styles.section}>
                    <Text style={styles.subtitle}>Entrega</Text>

                    {datos.crearRenders && (
                        <View style={styles.section}>
                            <View style={{ flexDirection: "row", gap: 20 }}>
                                {columnas.map((columna, colIndex) => (
                                    <View key={colIndex} style={{ flex: 1 }}>
                                        {columna.map((item, itemIndex) => (
                                            <View key={itemIndex}>{item}</View>
                                        ))}
                                    </View>
                                ))}
                            </View>
                        </View>
                    )}
                </View>
                {datos.incluye && (
                    <View style={styles.section}>
                        <Text style={styles.subtitle}>Incluye</Text>
                        <Text>• {datos.incluye}</Text>
                    </View>
                )}
                {/* {renderLinea('Videos (animaciones/renders) vuelos transiciones para la intro x7 de 3seg', datos.videos)}
                    {renderLinea('Animación vuelo a torre', datos.vueloTorre)}
                    {renderLinea('Renders Disponibilidad', datos.rendersDisponibilidad)}
                    {renderLinea('Animación Luma IA', datos.animacionLuma)}
                    {renderLinea('Unidades habitacionales', datos.unidadesHabitacionales)}
                    {cantidadUnidades > 0 &&
                        renderLinea(
                            `Precio por unidades (${cantidadUnidades})`,
                            `$${precioPorUnidades} COP`
                        )}
                    {renderLinea(
                        'Interiores 360 x nodo',
                        `${datos.interiores360}`
                    )}
                    {datos.vueloDroneActivado &&
                        renderLinea(
                            'Vuelo de drone',
                            `$${Number(datos.vueloDrone).toLocaleString()} COP`
                        )} */}
                <View style={styles.section}>
                    <Text style={styles.subtitle}>PRECIO: ${totales.subtotal.toLocaleString('es-CO')}</Text>
                    <Text style={styles.subtitle}>COP IVA: ${totales.iva.toLocaleString('es-CO')}</Text>
                    <Text style={styles.subtitle}>COP</Text>
                    {/* {renderLinea('Pago', datos.formaPago)}
                    {datos.formaPago === 'Cuotas' &&
                        renderLinea('Nota', datos.notaPagoCuotas)} */}
                </View>

                <View style={styles.section}>
                    <Text style={styles.subtitle}>Tiempo de entrega 15 días hábiles</Text>
                </View>

                {camposExtras && camposExtras.length > 0 && (
                    <View style={styles.section}>
                        <Text style={styles.subtitle}>Campos Adicionales</Text>
                        {camposExtras.map((campo, idx) => (
                            <Text key={idx} style={styles.line}>
                                <Text style={styles.bold}>{campo.nombre}: </Text>
                                <Text>{campo.valor}</Text>
                            </Text>
                        ))}
                    </View>
                )}

                <View style={styles.totalView}>
                    <Text style={styles.totalText}>
                        TOTAL: ${totales.total.toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} COP IVA INCLUIDO
                    </Text>
                </View>


                {/* <View style={styles.section}>
                    <Text style={styles.line}><Text style={styles.bold}>Subtotal:</Text> ${subtotal}</Text>

                    {(datos.descuentoValor || datos.descuentoPorcentaje) && (
                        <Text style={styles.line}>
                            <Text style={styles.bold}>Descuento aplicado:</Text>{' '}
                            {datos.descuentoValor
                                ? `$${Number(datos.descuentoValor).toLocaleString()}`
                                : `${Number(datos.descuentoPorcentaje)}%`}
                        </Text>
                    )}

                    {totales.iva > 0 && (
                        <Text style={styles.line}>
                            <Text style={styles.bold}>IVA (19%):</Text> ${totales.iva.toLocaleString()}
                        </Text>
                    )}
                    {totales.reteFuente > 0 && (
                        <Text style={styles.line}>
                            <Text style={styles.bold}>ReteFuente (2.5%):</Text> -${totales.reteFuente.toLocaleString()}
                        </Text>
                    )}
                    {totales.reteICA > 0 && (
                        <Text style={styles.line}>
                            <Text style={styles.bold}>ReteICA (0.9%):</Text> -${totales.reteICA.toLocaleString()}
                        </Text>
                    )}
                    {totales.reteIVA > 0 && (
                        <Text style={styles.line}>
                            <Text style={styles.bold}>ReteIVA (15% del IVA):</Text> -${totales.reteIVA.toLocaleString()}
                        </Text>
                    )}

                    <Text style={styles.line}><Text style={styles.bold}>Total:</Text> ${total}</Text>
                </View> */}



                {/* <Text style={{ fontSize: 10, marginTop: 20 }}>
                    Fecha de generación: {fecha}
                </Text> */}
            </Page>

            <Page size="LETTER" style={styles.page}>
                <View style={styles.headerBar}>
                    <Svg viewBox="0 0 630 50" width="100%" height="50">
                        <Polygon
                            points="0,0 380,0 345,50 0,50"
                            fill="#D3D3D3"
                        />
                    </Svg>
                </View>

                <View style={styles.footerBar} fixed>

                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                        <Image
                            src={phone}
                            style={{ width: 22, height: 20, marginRight: 5 }}
                        />
                        <Text style={{ fontSize: 12, fontWeight: 'bold' }}>(+57) 3166994046</Text>
                    </View>


                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                        <Image
                            src={red}
                            style={{ width: 23, height: 20, marginRight: 5 }}
                        />
                        <Text style={{ fontSize: 12, fontWeight: 'bold' }}>www.armyone.co</Text>
                    </View>


                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                        <Image
                            src={email}
                            style={{ width: 23, height: 20, marginRight: 5 }}
                        />
                        <Text style={{ fontSize: 12, fontWeight: 'bold' }}>manager@armyone.co</Text>
                    </View>
                </View>

                <View style={{ alignItems: 'center', marginTop: 35 }}>
                    <Image src={logo} style={styles.logo} />
                    <View>
                        <Text style={{ fontSize: 12, fontWeight: 'bold' }}>MÉTODO DE PAGO</Text>
                    </View>
                    <View style={{ alignItems: 'center', marginTop: 110 }}>
                        <Text style={styles.textPage2}>TRANSFERENCIA</Text>
                        <Text style={styles.textPage2}>BANCOLOMBIA</Text>
                        <Image
                            src={banco}   // tu PNG con transparencia
                            style={{ width: 135, height: 128, marginTop: 20 }}
                        />
                    </View>
                    <View style={{ alignItems: 'center', marginTop: 26 }}>
                        <Text style={styles.textPage2}>829-000131-38 (Ahorros)</Text>
                        <Text style={{ marginTop: 18 }}></Text>
                        <Text style={styles.textPage2}>ARMYONE SAS</Text>
                        <Text style={{ marginTop: 16 }}></Text>
                        <Text style={styles.textPage2}>NIT: 901731529</Text>
                        <Text style={{ marginTop: 16 }}></Text>
                        <Text style={styles.textPage2}>Contacto:</Text>
                        <Text style={{ marginTop: 16 }}></Text>
                        <Text style={styles.textPage2}>+57-3164385080</Text>
                    </View>
                </View>
            </Page>

            <Page size="LETTER" style={styles.page}>
                <View style={styles.headerBar}>
                    <Svg viewBox="0 0 630 50" width="100%" height="50">
                        <Polygon
                            points="0,0 380,0 345,50 0,50"
                            fill="#D3D3D3"
                        />
                    </Svg>
                </View>

                <View style={styles.footerBar} fixed>

                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                        <Image
                            src={phone}
                            style={{ width: 22, height: 20, marginRight: 5 }}
                        />
                        <Text style={{ fontSize: 12, fontWeight: 'bold' }}>(+57) 3166994046</Text>
                    </View>


                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                        <Image
                            src={red}
                            style={{ width: 23, height: 20, marginRight: 5 }}
                        />
                        <Text style={{ fontSize: 12, fontWeight: 'bold' }}>www.armyone.co</Text>
                    </View>


                    <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                        <Image
                            src={email}
                            style={{ width: 23, height: 20, marginRight: 5 }}
                        />
                        <Text style={{ fontSize: 12, fontWeight: 'bold' }}>manager@armyone.co</Text>
                    </View>
                </View>

                <View style={{ alignItems: 'center', marginTop: 20 }}>
                    <Image src={logo} style={styles.logo} />
                </View>

                <View style={styles.condiciones}>
                    <Text style={styles.subtitle}>CONDICIONES:</Text>
                    <Text style={styles.condicionesText}>• Una vez el proyecto ya haya sido lanzado al público general, Armyone tiene el derecho de utilizar la información sobre el proyecto producido como material promocional de la marca en redes sociales y la página web o a través de cualquier otro medio, ya sea impreso o en línea.</Text>
                    <Text style={styles.condicionesText}>• El cliente adquiere el compromiso de entregar los datos, información y documentación necesaria para llevar a cabo las acciones relacionadas con la visualización de arquitectura y gestiones que solicite ArmyOne para el adecuado desarrollo del trabajo. En caso contrario, ArmyOne podrá aplazar las entregas parciales pactadas, así como la fecha final acordada de la entrega del proyecto.</Text>
                    <Text style={styles.condicionesText}>• La inactividad de un proyecto de visualización de arquitectura, maquetas virtuales, animaciones 3D o nodos 360, por parte del cliente por un periodo de tres semanas causará su facturación por el 80% de su valor. El proyecto se retomará de acuerdo al orden de prioridades de ArmyOne.</Text>
                    <Text style={styles.condicionesText}>• En caso de que el cliente no acepte alguna de las imágenes, animaciones 3D, nodos 360, maquetas virtuales o proyectos presentados por ArmyOne, este renuncia a cualquier derecho que pudiese llegar a tener sobre ellos, de esta manera quedando a disposición de ArmyOne, que es el autor, para que este decida el uso que quiera o crea apropiado.</Text>
                    <Text style={styles.condicionesText}>• Como parte de la entrega final solo se entrega el producto final y no las herramientas que se usaron para llegar a ello.</Text>
                    <Text style={styles.condicionesText}>• ArmyOne enviará la página web final, imágenes finales, animaciones finales o 360 finales PARA REVISIÓN, la cual deberá ser revisada por el cliente y así corroborar toda la información antes de empezar cualquier proceso de impresión, reproducción, uso y/o difusión. Por esta razón, a menos que el cliente hubiese comunicado errores con anterioridad y ArmyOne no los hubiese tenido en cuenta por error, ArmyOne se absuelve de cualquier responsabilidad de los errores que se pudieran producir.</Text>
                    <Text style={styles.condicionesText}>• El cliente debe abstenerse a usar cualquier idea, información, concepto o material desarrollado por ArmyOne para fines diferentes a los estipulados.</Text>
                    <Text style={styles.condicionesText}>• El trabajo realizado por ArmyOne podrá ser usado como publicidad, para ser expuesto o para promocionar el estudio. ArmyOne debe recibir crédito por cualquier imagen o proyecto del que participa o ha participado.</Text>
                    <Text style={styles.condicionesText}>• Una vez el proyecto final ha sido aprobado y recibido por el cliente, toda modificación tendrá un costo adicional sobre el valor total de trabajo solicitado.</Text>
                    <Text style={styles.condicionesText}>• Después de que ArmyOne haya terminado el trabajo, el 100% restante del estimado es recibido.</Text>
                    <Text style={styles.condicionesText}>• Esta cotización tiene validez por 30 días hábiles a partir de la fecha.</Text>
                </View>
            </Page>
        </Document>
    );
}

export default PDFCotizacion;
